import React, { useState, useRef } from "react";
import { Modal, Checkbox, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import useFetch from '../../hooks/useFetch'
import './index.css'

const DownLoad = () => {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  // const modalText = useFetch('http://1.94.62.64:9090/myf/products/detail')
  const modalText = useFetch('http://1.94.62.64:9090/myf/CommunityData')

  const communityMessage = useFetch("http://1.94.62.64:9090/myf/CommunityMessage")
  const enterPriseMessage = useFetch("http://1.94.62.64:9090/myf/EnterpriseMessage")

  const downLoadData = useRef([])
  const navigate = useNavigate();

  const handleOk = () => {
    if (downLoadData.current.length !== 0) {
      setConfirmLoading(true);
      fetch("http://1.94.62.64:9090/myf/CommunityData", {
        method: "POST",
        body: JSON.stringify(downLoadData.current),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(() => {
        message.success("提交成功")
      }).catch(() => {
        message.error('提交失败，请检查网络或提交信息是否正常')
      }).finally(() => {
        setConfirmLoading(false)
      })
    } else {
      setOpen(false)
    }
  };

  const handleDownload = (key) => {
    downLoadData.current = [...downLoadData.current, key];
  };

  return (
    <>
      <div className="download-image h-[500px] flex justify-center items-center">
        <h3 className="text-3xl text-slate-50 font-semibold">下载墨圆方社区或企业免费使用版本</h3>
      </div>
      <div className="flex flex-col items-center">
        <div className="flex w-full justify-center space-x-24 items-center bg-slate-100  my-20 py-10 rounded-md">
          <Card className="flex flex-col justify-evenly w-[600px] h-[300px]">
            <h6 className="text-2xl font-semibold">社区版</h6>
            <div className="px-2 text-xl py-4">
              <p>1. {communityMessage ? communityMessage[0] : "加载中，请稍候..."}</p>
              <p>2. {communityMessage ? communityMessage[1] : "加载中，请稍候..."}</p>
            </div>
            <Modal
              title="下载内容"
              open={open}
              onOk={handleOk}
              confirmLoading={confirmLoading}
              onCancel={() => setOpen(false)}
              width={600}
              okText='确定'
              cancelText='取消'
            >
              {modalText
                ? modalText.map((item) => {
                  return (
                    <div key={item.id} className="flex items-center justify-between">
                      <span className="mt-4">{item.id + '. ' + item.name}</span>
                      {
                        item.isProvide === 0 ? <span className="flex justify-center items-center mt-4">暂不提供</span> : (
                          <Checkbox
                            size="small"
                            onChange={() => handleDownload(item.id)}
                          />
                        )
                      }
                    </div>
                  );
                })
                : "加载中，请稍候..."}
            </Modal>
            <button
              className="rounded-md w-full text-slate-100 py-6 bg-blue-600 hover:bg-yellow-500 text-xl hover:font-semibold transition-all duration-500"
              onClick={() => setOpen(true)}
            >
              立即下载
            </button>
          </Card>
          <Card className="flex flex-col justify-evenly w-[600px] h-[300px]">
            <h6 className="text-2xl font-semibold">企业试用版</h6>
            <div className="px-2 text-xl py-4">
              <p>1. {enterPriseMessage ? enterPriseMessage[0] : "加载中，请稍候..."}</p>
              <p>2. {enterPriseMessage ? enterPriseMessage[1] : "加载中，请稍候..."} </p>
            </div>
            <button
              className="rounded-md w-full py-6 text-slate-100 bg-blue-600 hover:bg-yellow-500 text-xl hover:font-semibold transition-all duration-500"
              onClick={() => navigate("/download/tryBussines")}
            >
              立即申请
            </button>
          </Card>
        </div>
      </div>
    </>
  );
};

export default DownLoad;
